import { render } from "./KryptonIdentityDocType.vue?vue&type=template&id=ebeb8d4c&lang=pug"
import script from "./KryptonIdentityDocType.vue?vue&type=script&lang=js"
export * from "./KryptonIdentityDocType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__